module.exports = __webpack_public_path__ + "static/media/color.8ef55329.jpg";